module.exports = __webpack_public_path__ + "img/logo-tradenow.f5b96d7c.png";